import styled from '@emotion/styled'
import { useRouter } from 'next/router'

import Breadcrumb, { type BreadcrumbProps } from '../Breadcrumb/Breadcrumb'
import { Container } from '../Container'

import { createBreadcrumbItems } from './utils'

const StyledBreadcrumb = styled(Breadcrumb)`
  transition: brightness 0.3s ease-in-out;
  &.ea-typography--emphasys:hover {
    filter: brightness(110%);
  }
  &.--dark-high {
    color: rgba(var(--colors-text-dark-high));
  }
`

function BlogBreadcrumb({ items, ...props }: Partial<BreadcrumbProps>) {
  const { asPath } = useRouter()

  const segmentedItems = items || createBreadcrumbItems(asPath)

  return (
    <Container className="eu-smt-3 eu-sm-2">
      <StyledBreadcrumb items={segmentedItems} {...props} />
    </Container>
  )
}

export default BlogBreadcrumb
